import { render, staticRenderFns, recyclableRender, components } from "./merchantActivity.vue?vue&type=template&id=58b91759&"
var renderjs
import script from "./merchantActivity.vue?vue&type=script&lang=js&"
export * from "./merchantActivity.vue?vue&type=script&lang=js&"
import style0 from "./merchantActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/merchatCenter/merchantActivity/merchantActivity.vue"
export default component.exports